<ng-template #content><ng-content /></ng-template>

@if (routerLinkURL && !isExternalLink) {
    <div>
        @if (matButton) {
            <a
                [id]="idRedirect"
                mat-button
                routerLinkActive="router-link-active"
                [routerLinkActiveOptions]="{ exact: true }"
                [routerLink]="routerLinkURL"
            >
                <ng-container *ngTemplateOutlet="content" />
            </a>
        }
        @if (matListItem) {
            <a
                [id]="idRedirect"
                mat-list-item
                routerLinkActive="router-link-active"
                [routerLinkActiveOptions]="{ exact: true }"
                [routerLink]="routerLinkURL"
            >
                <ng-container *ngTemplateOutlet="content" />
            </a>
        }
    </div>
} @else {
    @if (safeUrl) {
        <div>
            @if (matButton) {
                <a href="#" [id]="idRedirect" mat-button (click)="redirectExternalLink($event)">
                    <ng-container *ngTemplateOutlet="content" />
                </a>
            }
            @if (matListItem) {
                <a href="#" [id]="idRedirect" mat-list-item (click)="redirectExternalLink($event)">
                    <ng-container *ngTemplateOutlet="content" />
                </a>
            }
        </div>
    }
}
